import isEqual from 'lodash/isEqual';

import { MapAdvancedMarkerProps } from './map-advanced-marker.props';

export const areMarkerPropsEqual = (
    prevProps: MapAdvancedMarkerProps,
    nextProps: MapAdvancedMarkerProps,
): boolean => {
    return (
        prevProps.isSelected === nextProps.isSelected &&
        prevProps.rate === nextProps.rate &&
        prevProps.currency === nextProps.currency &&
        prevProps.reservationType === nextProps.reservationType &&
        prevProps.count === nextProps.count &&
        prevProps.type === nextProps.type &&
        prevProps.isUnavailable === nextProps.isUnavailable &&
        prevProps.isInitiallySelected === nextProps.isInitiallySelected &&
        prevProps.id === nextProps.id &&
        isEqual(prevProps.position, nextProps.position) &&
        isEqual(prevProps.style, nextProps.style)
    );
};
